import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Padding from "%/dynamic-component-editor/options/padding";
import Margins from "%/dynamic-component-editor/options/margins";

export default class SpacingOptions extends BaseOptionsBundle {

  optionTitle = "Spacing";
  static optionClassName = "i-dynamic-spacing";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Padding(undefined, hideFromInspector["padding"] ?? false),
      new Margins(undefined, hideFromInspector["margins"] ?? false),
    ]);
  }
}
